import { useLocation } from "react-router";

import { ICON_DEFAULT_STYLE, LAST_DOWNLOAD_STATUS } from "@/shared";

import { colors } from "@dotnet/telematics-design-system";

import SharedStatusBadge from "../../../SharedStatusBadge/SharedStatusBadge";
import { useLastDownloadFormatting } from "./hooks/useLastDownloadFormatting";

interface ISharedLastDownloadBadge {
  lastDownloadDate: string;
  isDisabled?: boolean;
}

const SharedLastDownloadBadge = ({
  lastDownloadDate,
  isDisabled
}: ISharedLastDownloadBadge) => {
  const location = useLocation();

  const { tooltipText, getDownloadStatus } = useLastDownloadFormatting(
    lastDownloadDate,
    location.pathname
  );

  const { Icon, status, text } = getDownloadStatus();

  const iconColor =
    status === LAST_DOWNLOAD_STATUS.Warning ? colors.orange600 : undefined;

  return (
    <SharedStatusBadge
      status={status}
      customTooltipText={tooltipText}
      tooltipSize="medium"
      badgeText={text}
      iconLeft={<Icon style={ICON_DEFAULT_STYLE} color={iconColor} />}
      isDisabled={isDisabled}
    />
  );
};

export default SharedLastDownloadBadge;
